import { toast } from '@heidi/design-system/toast';
import { useTranslations } from '@heidi/runtime/i18n';

import { useIsOfflineConnectivity } from '@/hooks/desktop/useIsOfflineConnectivity';
import { MAX_QUERY_RETRIES } from '@/hooks/query/constants';
import { isSessionNotFoundError } from '@/lib/SessionRecordingProvider/errors';
import { canPersistSessionToServer } from '@/utils/offline-recording/canPersistSessionToServer';
import { useMutateUpdateSessionDuration as useMutateUpdateSessionDurationCore } from '@heidi/session/data';

export const UPDATE_SESSION_DURATION_DEMO = 'updateSessionDurationDemo';

export function useMutateUpdateSessionDuration() {
  const { t } = useTranslations();
  const isOffline = useIsOfflineConnectivity();

  return useMutateUpdateSessionDurationCore({
    isOffline,
    canPersist: canPersistSessionToServer,
    retry: MAX_QUERY_RETRIES,
    shouldRetry: (error) => !isSessionNotFoundError(error),
    onDurationError: (error) =>
      toast({
        tone: 'destructive',
        title: t('toast.backendError'),
        description: error.message,
      }),
  });
}
